import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Menu, Tooltip } from 'antd';
import _ from 'lodash';
import languageFile from '../../../public/languages/Translation';
import urlConfig from '../../config/index';
import '../../components/SideBar/style.scss';
import { CustomScrollbar } from '../CustomScrollbar';
var cookie = require('../../utils/cookie');

var moment = require('moment');

class PortfolioSideBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			navigationGroup: [],
			adminRights: false,
			showBulkLocationEditTab: false,
			showBulEditByProfile: false,
			visibility: {},
			visibilityByDomain: {},
			tierVisibility: {},
			firstLoading: true,
			activeTabList: [''],
		};
		this.gotoHome = this.gotoHome.bind(this);
		this.activeRoute = this.activeRoute.bind(this);
	}
	gotoHome() {
		this.props.history.push('/authorize/portfolio');
	}

	componentWillMount() {}

	componentWillUnmount() {}

	activeRoute(routeName) {
		let style = {
			color: localStorage.getItem('activeIcon'),
			backgroundColor: localStorage.getItem('activeTabList'),
			transition: ' all 0.5s ease-in-out',
		};
		let normalStyle = {
			color: localStorage.getItem('tabIcon'),
			backgroundColor: localStorage.getItem('sidebarBackground'),
		};
		// console.log("this.props.location.pathname ===> ", this.props.location.pathname, routeName);
		return this.props.location.pathname.indexOf(routeName) === 0
			? style
			: normalStyle;
	}
	dynamicBorderColor = () => {
		let border = {
			borderColor:
				localStorage.getItem('sidebarBorder') +
				' transparent ' +
				localStorage.getItem('sidebarTransparency') +
				' transparent',
		};
		return border;
	};

	domainLogoLoaded = (event) => {
		const target = (event && event.target) || {};
		if(target.style) {
			target.style.opacity = 1;
		}
	}

	domainLogoNotLoaded = (event) => {
		const target = (event && event.target) || {};
		if(target.style) {
			target.style.opacity = 0;
		}
	}

	render() {
		var defaultKey = '1';

		switch (this.props.history.location.pathname) {
			case '/manageprofiles':
				defaultKey = '1';
				break;
			case '/manageusers':
				defaultKey = '2';
				break;
			/*case '/settings':
                defaultKey = '4';
                break;
            case '/settings/addAccount':
                defaultKey = '4';
                break;*/
			default:
				if (
					this.props.history.location.pathname.indexOf(
						'manageusers'
					) !== -1
				) {
					defaultKey = '1';
				}
				if (
					this.props.history.location.pathname.indexOf('settings') !==
					-1
				) {
					defaultKey = '5';
				}
				if (
					this.props.history.location.pathname.indexOf(
						'manageprofiles'
					) !== -1
				) {
					defaultKey = '2';
				}
		}

		var urlName = urlConfig.urlName;
		return (
			<div
				className='sidebar-block'
				style={{
					backgroundColor: localStorage.getItem('sidebarBackground'),
				}}>
				<Tooltip
					title={
						languageFile[localStorage.getItem('language')][
							'Profiles'
						]
					}
					placement='right'>
					<div
						onClick={this.gotoHome}
						className='logo'
						style={{
							backgroundColor:
								localStorage.getItem('logoBackground'),
						}}>
						<span className='logo-minimised'>
							<img
								onLoad={this.domainLogoLoaded}
								onError={this.domainLogoNotLoaded}
								src={
									localStorage.getItem('logo') +
									'?time=' +
									Date.now()
								}
							/>
						</span>
						<span className='logo-expanded'>
							<img
								onLoad={this.domainLogoLoaded}
								onError={this.domainLogoNotLoaded}
								src={
									localStorage.getItem('logoText') +
									'?time=' +
									Date.now()
								}
							/>
						</span>
					</div>
				</Tooltip>
				<div className='menu-block'>
					<CustomScrollbar className='menu-scroller'>
						<ul className='sidebar-menu'>
							{/* {this.visibilityChecker('DASHBOARD') &&  */}
							<li key='1' style={this.dynamicBorderColor()}>
								<Tooltip
									title={
										languageFile[
											localStorage.getItem('language')
										]['27851']
									}
									placement='right'>
									<Link
										to='/manageprofiles'
										style={this.activeRoute(
											'/manageprofiles'
										)}>
										<span className='nav-icon'>
											<svg
												class=''
												fill='currentColor'
												width='28.305'
												height='39'
												viewBox='0 0 28.305 39'>
												<path
													id='Path_23'
													data-name='Path 23'
													d='M20481.668,19871a.643.643,0,0,1-.637-.566l-.1-.807a3.541,3.541,0,0,1-.586-.248l-.643.5a.64.64,0,0,1-.854-.051l-.674-.68a.632.632,0,0,1-.051-.848l.5-.643a3.773,3.773,0,0,1-.246-.592l-.807-.1a.639.639,0,0,1-.566-.637v-.963a.648.648,0,0,1,.566-.637l.807-.1a3.708,3.708,0,0,1,.246-.586l-.5-.643a.64.64,0,0,1,.051-.854l.68-.678a.636.636,0,0,1,.848-.047l.643.494a4.1,4.1,0,0,1,.586-.242l.1-.807a.643.643,0,0,1,.637-.566h.967a.635.635,0,0,1,.633.566l.107.807a4.2,4.2,0,0,1,.586.242l.643-.494a.639.639,0,0,1,.854.051l.674.68a.634.634,0,0,1,.057.848l-.5.643a3.907,3.907,0,0,1,.248.586l.807.1a.643.643,0,0,1,.564.637v.963a.639.639,0,0,1-.564.637l-.807.1a3.977,3.977,0,0,1-.248.592l.5.643a.642.642,0,0,1-.057.854l-.678.674a.634.634,0,0,1-.85.051l-.643-.5a3.612,3.612,0,0,1-.586.248l-.107.807a.635.635,0,0,1-.633.566Zm-1.66-5.152a2.146,2.146,0,1,0,2.145-2.145A2.147,2.147,0,0,0,20480.008,19865.85Zm-6.268,2.133v-24.6h9.6v16.125a.68.68,0,0,0-.01.113.588.588,0,0,1-.592.586h-1.537a4.694,4.694,0,0,0-4.686,4.684v3.09Zm1.5-4.977a.491.491,0,0,0,.488.488h.391a.488.488,0,0,0,0-.977h-.391A.491.491,0,0,0,20475.236,19863.006Zm0-4.01a.491.491,0,0,0,.488.488h4.422a.488.488,0,0,0,0-.977h-4.422A.487.487,0,0,0,20475.236,19859Zm0-4.016a.488.488,0,0,0,.488.488h4.422a.486.486,0,1,0,0-.973h-4.422A.488.488,0,0,0,20475.236,19854.98Zm0-4.012a.489.489,0,0,0,.488.49h4.422a.486.486,0,1,0,0-.973h-4.422A.487.487,0,0,0,20475.236,19850.969Zm0-4.01a.491.491,0,0,0,.488.488h4.422a.488.488,0,0,0,0-.977h-4.422A.491.491,0,0,0,20475.236,19846.959Zm-16.238,21.02V19839.9h13.77v28.074Zm2.5-3.486a.491.491,0,0,0,.488.488h7.795a.488.488,0,0,0,0-.977h-7.795A.491.491,0,0,0,20461.5,19864.492Zm0-4.1a.488.488,0,0,0,.488.488h7.795a.486.486,0,1,0,0-.973h-7.795A.488.488,0,0,0,20461.5,19860.395Zm0-4.094a.487.487,0,0,0,.488.488h7.795a.488.488,0,0,0,0-.977h-7.795A.491.491,0,0,0,20461.5,19856.3Zm0-4.092a.491.491,0,0,0,.488.488h7.795a.488.488,0,0,0,0-.977h-7.795A.491.491,0,0,0,20461.5,19852.209Zm0-4.1a.488.488,0,0,0,.488.488h7.795a.486.486,0,1,0,0-.973h-7.795A.488.488,0,0,0,20461.5,19848.111Zm0-4.094a.487.487,0,0,0,.488.488h7.795a.488.488,0,0,0,0-.977h-7.795A.491.491,0,0,0,20461.5,19844.018Zm-.422-5.09v-3.07h9.615v3.07Zm4.447-3.609v-2.828a.486.486,0,1,1,.973,0v2.828Z'
													transform='translate(-20458.998 -19832.002)'
												/>
											</svg>
										</span>
										<span className='nav-label'>
											{
												languageFile[
													localStorage.getItem(
														'language'
													)
												]['27851']
											}
										</span>
									</Link>
								</Tooltip>
							</li>
							<li key='2' style={this.dynamicBorderColor()}>
								<Tooltip
									title={
										languageFile[
											localStorage.getItem('language')
										]['27001']
									}
									placement='right'>
									<Link
										to='/manageusers'
										style={this.activeRoute(
											'/manageusers'
										)}>
										<span className='nav-icon'>
											<svg
												class=''
												fill='currentColor'
												width='33.002'
												height='32.41'
												viewBox='0 0 33.002 32.41'>
												<path
													id='Path_16'
													data-name='Path 16'
													d='M20469.018,19864.408v-.016a.118.118,0,0,1,.016.016Zm13.537-.586a2.9,2.9,0,0,0,.605-1.77v-5.895a5.428,5.428,0,0,0-.3-1.748c.1,0,.2-.016.3-.016h4.717a4.077,4.077,0,0,1,2.318.715,4.143,4.143,0,0,1,1.807,3.41v2.355a2.963,2.963,0,0,1-1.729,2.68,2.725,2.725,0,0,1-.633.205v-6.424h-1.178v6.486Zm-2.932,0v-8.25h-1.178v8.25h-5.895v-8.25h-1.178v8.25h-.586a1.77,1.77,0,0,1-1.77-1.77v-5.895a4.124,4.124,0,0,1,4.125-4.123h4.717a4.125,4.125,0,0,1,2.145.605,1.361,1.361,0,0,1,.174.109,4.265,4.265,0,0,1,1.322,1.471,4.121,4.121,0,0,1,.482,1.938v5.895a1.769,1.769,0,0,1-1.768,1.77Zm-17.09,0v-6.486h-1.178v6.424a2.609,2.609,0,0,1-.643-.211,2.957,2.957,0,0,1-1.713-2.674v-2.355a4.131,4.131,0,0,1,1.8-3.41,4.039,4.039,0,0,1,2.32-.715h4.715c.1,0,.2.012.3.016a5.177,5.177,0,0,0-.3,1.748v5.895a2.869,2.869,0,0,0,.607,1.77Zm20.627-13.557a2.358,2.358,0,1,1,2.355,2.361A2.356,2.356,0,0,1,20483.16,19850.266Zm-20.035,0a2.357,2.357,0,1,1,2.355,2.361A2.356,2.356,0,0,1,20463.125,19850.266Zm10.018-2.355a2.358,2.358,0,1,1,2.355,2.355A2.356,2.356,0,0,1,20473.143,19847.91Zm5.416,1.77a3.537,3.537,0,1,0-6.115,0h-3.363a7.072,7.072,0,1,1,12.842,0Zm10.285-.592a3.523,3.523,0,0,0-5.117-1.867c.01-.164.025-.324.025-.488a8.251,8.251,0,0,0-16.5,0c0,.164.014.324.025.488a3.527,3.527,0,0,0-5.123,1.867h-.8a.585.585,0,0,1-.586-.586v-3.539a.585.585,0,0,1,.586-.586h3.184l.117-.447a10.869,10.869,0,0,1,1.205-2.875l.236-.4-2.264-2.262a.58.58,0,0,1-.174-.418.563.563,0,0,1,.174-.41l2.5-2.506a.6.6,0,0,1,.828,0l2.262,2.258.4-.23a10.757,10.757,0,0,1,2.881-1.2l.441-.113v-3.184a.591.591,0,0,1,.592-.592h3.533a.6.6,0,0,1,.592.592v3.184l.441.113a11.033,11.033,0,0,1,2.881,1.2l.395.236,2.264-2.264a.593.593,0,0,1,.822,0l2.506,2.506a.59.59,0,0,1,.174.416.6.6,0,0,1-.174.412l-2.258,2.262.236.4a10.784,10.784,0,0,1,1.2,2.875l.119.447h3.178a.586.586,0,0,1,.592.586v3.539a.586.586,0,0,1-.592.586Z'
													transform='translate(-20459 -19831.998)'
												/>
											</svg>
										</span>
										<span className='nav-label'>
											Manage Users
										</span>
									</Link>
								</Tooltip>
							</li>
						</ul>
					</CustomScrollbar>
				</div>
				<div key='5' className='setting-block'>
					<Tooltip
						title={
							languageFile[localStorage.getItem('language')][
								'13825'
							]
						}
						placement='right'>
						<Link
							to='/portfoliosettings/editPortfolio'
							style={this.activeRoute('/portfoliosettings')}>
							<span className='nav-icon'>
								<i
									className='fa fa-wrench'
									aria-hidden='true'></i>
							</span>
							<span className='nav-label'>
								{' '}
								{
									languageFile[
										localStorage.getItem('language')
									]['13825']
								}
							</span>
						</Link>
					</Tooltip>
				</div>
			</div>
		);
	}
}

export default withRouter(PortfolioSideBar);
